import { defineStore } from 'pinia'
export const langStore = defineStore('langStore', {
    state: () => {
        return {
            langSelected: process.env.VUE_APP_I18N_LOCALE,
        }
    },
    getters: {
        getLangSelected: (state) => {
            return state.langSelected;
        },
    },
    persist: {
        storage: localStorage,
        paths: ['langSelected'],
    },
})